function geocoderAddress(marker, start_location){

    return new Promise(resolve => {

        googleGeocoder(marker.position.lat(), marker.position.lng()).then(googleGeocoderResponse => {

            marker.data.address = getAddressFromGoogleGeocoderResponse(googleGeocoderResponse);

            if(!start_location) return;

            $.post('/ajax/getLocationEntity', {
                position: marker.position.lat()+','+marker.position.lng(),
                    google_geocoded: JSON.stringify(googleGeocoderResponse)
                },
                function(d){

                    let data = typeof d === 'object' ? d : JSON.parse(d);

                    if(data.status === 'ok'){

                        let countrySelect = $('select[name=country_id]');
                        let stateSelect = $('select[name=state_id]');
                        let cityId = $('input[name=city_id]');
                        let cityName = $('input#city');

                        let inputAddress = $('input[name=address]');

                        let location = data.data.locations[0];

                        if(location){

                            if(inputAddress.length > 0){
                                inputAddress.val(marker.data.address);
                            }

                            let location_address = '<span>' + location.formatted + '</span><span>' + marker.data.address + '</span>';

                            if(location.country){
                                countrySelect.val(location.country.id);
                                countrySelect.trigger('change');
                                countrySelect.trigger('chosen:updated');
                            }

                            $(document).on('loaded_state_form', function(){
                                if(location.state){
                                    stateSelect.val(location.state.id);
                                    stateSelect.trigger('chosen:updated');
                                }else{
                                    stateSelect.val('');
                                    stateSelect.trigger('chosen:updated');
                                }
                            })

                            if(!location.state){
                                stateSelect.val('');
                                stateSelect.trigger('chosen:updated');
                            }

                            let locationElement = $('#location');
                            if(data.data.locations.length === 1){
                                if(location.city){
                                    cityId.val(location.city.id);
                                    cityName.val(location.city.name);

                                    locationElement.addClass('hide');
                                }else{
                                    locationElement.removeClass('hide');
                                }
                            }else{
                                locationElement.removeClass('hide');
                            }

                            $('#location-address').html(location_address);
                        }else{
                            countrySelect.val('');
                            stateSelect.val('');
                            cityId.val('');
                            cityName.val('');
                            inputAddress.val('');
                        }

                        resolve(location);

                    }
                }
            )

        })

    })

}

const googleGeocoder = function(lat, lng){

    return new Promise(resolve => {
        $.ajax({
            url: "https://maps.googleapis.com/maps/api/geocode/json",
            dataType: "json",
            async: false,
            data: {
                result_type: "street_address|route|locality|administrative_area_level_1|country",
                latlng: lat + ',' + lng,
                language: "en",
                key: "AIzaSyB0y-D7-Wh6t1lyNoBvlHJqLq1smR6Bk8I"
            },
            success: function(response){
                if(response.status === "OK"){
                    resolve(response);
                }
            }
        })
    })

}

const getAddressFromGoogleGeocoderResponse = function(googleResponse){

    return googleResponse.results.length > 0 ? googleResponse.results[0].formatted_address : null;

}

export {geocoderAddress, googleGeocoder}